import { defineStore } from 'pinia';
import apiFetch from '@wordpress/api-fetch';

export const useCitiesStore = defineStore('cities', {
  state: () => ({
    cities: [],
    activeCities: [],
  }),

  actions: {
    loadCities(params = {}) {
      this.cities = [];

      const query = new URLSearchParams();

      if (params.lang) {
        query.append('lang', params.lang);
      }

      return apiFetch({
        path: `/wp-json/ebus/market/cities?${query.toString()}`,
      }).then((data) => {
        this.cities = data;

        return data;
      }).catch((error) => {
        console.log('Error: ', error);
      });
    },

    toggleCity(citySlug) {
      const index = this.activeCities.indexOf(citySlug);

      if (index === -1) {
        this.activeCities.push(citySlug);
      } else {
        this.activeCities.splice(index, 1);
      }
    },

    resetActiveCities() {
      this.activeCities = [];
    },
  },
});
